/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/aria-role */
import React from "react";
import { Modal } from "react-bootstrap";

const MarkCriticalModal = ({ show, onHide, confirmAction }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="MarkCriticalModal"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <div className="MarkCriticalModalBody">
          <a
            className="MarkCriticalModal_Close"
            role="buton"
            onClick={onHide}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
            >
              <path
                d="M10.0518 1L1 10"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1 1L10.0518 10"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <h3>
            Are you sure you want to mark this ticket as Critical?
          </h3>
          <p>
            Once marked, any further update will trigger emails to
            L1-L4 levels of your department.
            Please check your
            <a href="/hierarchy" target="_blank" role="button"> hierarchy</a> here.
          </p>
          <div className="MarkCriticalModal_Actions d-flex align-items-center justify-content-center">
            <button
              className="btn cancel me-2"
              onClick={onHide}
            >
              Cancel
            </button>
            <button className="btn" onClick={confirmAction}>
              Confirm
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MarkCriticalModal;
